import {BaseService} from '../baseService.js';

/* 
 * Handles Data Transform Rule Sets
 */
export class DataTransformRuleSetService extends BaseService {

	constructor() {	
		super();
	}
	
	async getDataTransformRuleSets(dataType) {
		var params = '';
		if (dataType) {
			params = '?dataType=' + encodeURIComponent(dataType);
		}
		var data = await this.makeGETRequest('/api/resource/data-transform-rule-sets' + params);
		return data;
	}

	async getFieldDefinitions(dataType) {
		var data = await this.makeGETRequest('/api/resource/data-transform-rule-sets/field-definitions/' + dataType);
		return data;
	}

	async getTransforms() {
		var data = await this.makeGETRequest('/api/resource/data-transform-rule-sets/transforms');
		return data;
	}

	async saveDataTransformRuleSet(ruleSet, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/data-transform-rule-sets/' + ruleSet.dataTransformRuleSetId, ruleSet);
		} else {
			saved = await this.makePOSTRequest('/api/resource/data-transform-rule-sets', ruleSet);
		}
		return saved;
	}	
	
	async deleteDataTransformRuleSet(dataTransformRuleSetId) {		
		var result = await this.makeDELETERequest('/api/resource/data-transform-rule-sets/' + dataTransformRuleSetId);		
		return result;
	}
	
	async activate(dataTransformRuleSetId) {
		var data = await this.makePUTRequest('/api/resource/data-transform-rule-sets/' + dataTransformRuleSetId + '/activate');
		return data;
	}
	
	async inactivate(dataTransformRuleSetId) {
		var data = await this.makePUTRequest('/api/resource/data-transform-rule-sets/' + dataTransformRuleSetId + '/inactivate');
		return data;
	}
	
}
